import { FormatDateType, formatDate } from '@/helpers/date';
import {
  COURSE_STATUS_LABEL_MAPPER,
  COURSE_YEAR_QUARTER_SEPARATOR,
} from './config';

export const durationDate = (startDate: Date, endDate: Date) => {
  const formattedStartDate = formatDate(startDate, FormatDateType.Standard);
  const formattedEndDate = formatDate(endDate, FormatDateType.Standard);

  if (formattedStartDate === formattedEndDate) {
    return formattedStartDate;
  }

  return `${formattedStartDate.slice(0, 3)} - ${formattedEndDate}`;
};

export const isEventOutdated = (date: Date) => date.getTime() < Date.now();

/**
 *
 * @returns ex. '2023-1'
 */
export const dateToYearQuarter = (date: Date) =>
  [date.getFullYear(), Math.ceil((date.getMonth() + 1) / 3)].join(
    COURSE_YEAR_QUARTER_SEPARATOR
  );

export const createYearQuarter = (
  yearQuarter: string,
  quarterNumber: number
) => {
  const [year] = yearQuarter.split(COURSE_YEAR_QUARTER_SEPARATOR);
  const date = new Date();
  date.setFullYear(+year);
  date.setDate(1);
  date.setMonth(date.getMonth() + quarterNumber * 3);
  return dateToYearQuarter(date);
};

export const yearQuarterToTitle = (
  value: ReturnType<typeof dateToYearQuarter>
) => {
  const [year, quarter] = value.split('-');
  return `Q${quarter} ${year}`;
};

export const getStatusLabel = (
  status: keyof typeof COURSE_STATUS_LABEL_MAPPER
) => COURSE_STATUS_LABEL_MAPPER[status];
